import { render, staticRenderFns } from "./workorder.vue?vue&type=template&id=0cdbfd34&"
import script from "./workorder.vue?vue&type=script&lang=js&"
export * from "./workorder.vue?vue&type=script&lang=js&"
import style0 from "./workorder.vue?vue&type=style&index=0&id=0cdbfd34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports